import { axiosInstance } from "./config";

const BASE_URL = "/banners";

export const getAllBanners = async () => {
  const res = await axiosInstance.get(BASE_URL);
  return res.data;
};

export const createBanner = async (data) => {
  const res = await axiosInstance.post(BASE_URL, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const updateBanner = async (id, data) => {
  const res = await axiosInstance.post(`${BASE_URL}/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteBanner = async (id) => {
  const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return res.data;
};
